<template>
  <div class="container">
    <h1>Versions</h1>
    <div class="mb-2 d-flex justify-content-center align-items-center">
      <p class="flex-fill m-0">
        Version actuelle:
        <span v-if="currentVersion" class="badge badge-primary">{{ currentVersion.version }}</span>
        <span v-else class="badge badge-light">Aucune</span>
      </p>
      <div>
        <button class="btn btn-sm btn-primary" @click="refresh()">Rafraichir</button>
      </div>
    </div>

    <b-table striped :items="list" :fields="fields" primary-key="id">
      <template #cell(id)="data">
        <span v-b-tooltip.hover :title="data.item.filename">
          {{ data.value }}
        </span>
      </template>

      <template #cell(description)="data">
        <b-badge
          v-if="data.value"
          variant="light"
          v-b-popover.hover.top="data.value"
          :title="data.item.version"
          class="text-truncate mt-1"
          style="max-width: 200px">
          {{ data.value }}
        </b-badge>
      </template>

      <template #cell(preRelease)="data">
        <b-badge v-if="data.value == true" variant="warning">Pré Release</b-badge>
        <b-badge v-else variant="light">Stable</b-badge>
      </template>

      <template #cell(enabled)="data">
        <b-badge v-if="data.value == true" variant="success">Oui</b-badge>
        <b-badge v-else variant="light">Non</b-badge>
      </template>

      <template #cell(createdAt)="data">
        {{ data.value | formatDate }}
      </template>

      <template #cell(actions)="data">
        <div class="d-flex">
          <b-button v-if="data.item.enabled == true" size="sm" variant="warning" @click="disableVersion(data.item)">
            Désactiver
          </b-button>
          <b-button v-else type="button" size="sm" variant="success" @click="enableVersion(data.item)">
            Activer
          </b-button>
          <b-button size="sm" variant="danger" class="ml-1" @click="destroyVersion(data.item)">Supprimer</b-button>
        </div>
      </template>
    </b-table>

    <b-pagination
      v-model="page"
      :total-rows="total_items"
      :per-page="per_page"
      aria-controls="my-table"
      first-text="Première"
      prev-text="Précédent"
      next-text="Suivant"
      last-text="Dernière"
      align="center"></b-pagination>
  </div>
</template>

<script>
  import axios from 'axios'
  import slice from 'lodash/slice'
  // import moment from 'moment';

  export default {
    name: 'Versions',
    computed: {
      headers() {
        return {
          Authorization: 'Bearer ' + this.token,
        }
      },
      fields() {
        return [
          {
            key: 'id',
            label: '#',
            sortable: false,
            sortDirection: 'asc',
            tdClass: 'text-center font-weight-bold',
          },
          // {
          //     key: 'filename',
          //     label: 'Fichier',
          //     sortable: false,
          //     thClass: 'text-center',
          //     tdClass: 'text-center',
          // },
          {
            key: 'version',
            label: 'Version',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'description',
            label: 'Description',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'preRelease',
            label: 'Pré Release',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'enabled',
            label: 'Activé',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'createdAt',
            label: 'Créé le',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'actions',
            label: '',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
        ]
      },
      list() {
        let start = (this.page - 1) * this.per_page
        let end = start + this.per_page
        return slice(this.total_list, start, end)
      },
      currentVersion() {
        return this.total_list.find((item) => item.enabled == true) || null
      },
    },
    data() {
      return {
        token: null,

        page: 1,
        per_page: 15,
        total_list: [],
        total_items: 5,
        total_pages: 3,
      }
    },
    components: {},
    methods: {
      async refreshList() {
        try {
          let response = await axios.get('/version', {
            params: {
              type: 'package',
            },
            headers: this.headers,
          })
          this.total_list = response.data

          this.total_items = this.total_list.length
          this.total_pages = Math.ceil(this.total_items / this.per_page)
        } catch (error) {
          this.$notify({
            type: 'error',
            title: 'Récupération de la liste des versions',
            text: error ? error : 'Erreur inconnue.',
          })
        }
      },
      async refresh() {
        try {
          let response = await axios.post(
            '/version/refresh',
            {},
            {
              headers: this.headers,
            }
          )

          // Des versions ont été ajoutées
          if (response.status == 201) {
            this.refreshList()

            this.$notify({
              type: 'success',
              title: 'Nouvelle version.',
              text: 'Une ou plusieurs versions ont été ajoutées.',
            })
          } else {
            this.$notify({
              type: 'warn',
              title: 'Aucune nouvelle version.',
              text: "Aucune nouvelle version n'a été trouvée.",
            })
          }
        } catch (error) {
          this.$notify({
            type: 'error',
            title: 'Erreur durant le rafraichissement',
            text: error ? error : 'Erreur inconnue.',
          })
        }
      },
      async disableVersion(item) {
        item.enabled = false
        await this.updateVersion(item)
        this.refreshList()
      },
      async enableVersion(item) {
        item.enabled = true
        await this.updateVersion(item)
        this.refreshList()
      },
      async updateVersion(item) {
        try {
          let response = await axios.put(
            '/version/' + item.id,
            {
              enabled: item.enabled,
            },
            {
              headers: this.headers,
            }
          )

          this.$notify({
            type: 'success',
            title: 'Modification réussie',
          })

          return response.data
        } catch (error) {
          this.$notify({
            type: 'error',
            title: 'Récupération de la mise à jour',
            text: error ? error : 'Erreur inconnue.',
          })
        }
      },
      async destroyVersion(item) {
        if (item.enabled == true) {
          this.$notify({
            type: 'error',
            title: 'Impossible de supprimer la version actuelle',
            text: "Vous devez d'abord désactiver la version actuelle.",
          })

          return
        }

        if (confirm('Êtes-vous sûr de vouloir supprimer cette la version ' + item.version + ' ?')) {
          try {
            await axios.delete('/version/' + item.id, {
              headers: this.headers,
            })

            this.$notify({
              type: 'success',
              title: 'Suppression réussie',
            })

            this.refreshList()
          } catch (error) {
            this.$notify({
              type: 'error',
              title: 'Suppression',
              text: error ? error : 'Erreur inconnue.',
            })
          }
        }
      },
    },
    mounted() {
      this.token = localStorage.getItem('jwt')
      if (!this.token) {
        this.$router.push('/login')
      }

      this.refreshList()
    },
  }
</script>
